import eventCollector from './event-collector'
import metrics from './metrics'

let currentlyViewable = false
let pastImpressionCount = 0
let pastViewableImpressionCount = 0

export const EVENT_AD_LOAD = `ad-load`
export const EVENT_IMPRESSION = `ad-impression`
export const EVENT_IMPRESSION_VIEWABLE = `ad-impression-viewable`
export const EVENT_AD_METRIC = `ad-metric`
export const EVENT_VIEWABLE_CHANGE = `viewable-changed`

eventCollector.on(EVENT_IMPRESSION, payload => {
  const labels = { viewable: `${currentlyViewable}`, ...getAdIdentifierLabels(payload) }
  metrics.counter(`ad_impression`, labels)
  pastImpressionCount++
})

eventCollector.on(EVENT_AD_LOAD, payload => {
  const labels = { viewable: `${currentlyViewable}`, ...getAdIdentifierLabels(payload) }
  metrics.counter(`ad_load`, labels)
})

function getAdIdentifierLabels(payload: any) {
  if (payload?.source === 'dtx') {
    return {
      ad_unit_path: payload.placementId,
      source: 'dtx'
    }
  }

  // GAM path
  if (payload?.slot) {
    return {
      ad_unit_path: payload.slot.getAdUnitPath(),
      source: 'gam'
    }
  }

  return {
    source: 'unknown'
  }
}

eventCollector.on(EVENT_IMPRESSION_VIEWABLE, payload => {
  const labels = { viewable: `${currentlyViewable}`, ...getAdIdentifierLabels(payload) }
  metrics.counter(`ad_impression_viewable`, labels)
  pastViewableImpressionCount++
})

eventCollector.on(EVENT_AD_METRIC, payload => {
  if (payload.metric) {
    const labels = { ...getAdIdentifierLabels(payload) }
    metrics.counter(`dtx_ad_metric_${payload.metric}`, labels)
  }
})

eventCollector.on(EVENT_VIEWABLE_CHANGE, payload => {
  currentlyViewable = !!payload.viewable
  const labels = {
    viewable: `${currentlyViewable}`,
    past_count: `${pastImpressionCount}`,
    past_count_viewable: `${pastViewableImpressionCount}`,
    ...getAdIdentifierLabels(payload)
  }
  metrics.counter(`viewable_changed`, labels)
})

export default eventCollector

// For testing purposes
export const _private = {
  getAdIdentifierLabels
}
